import { CompleteOrder } from 'api/textile_deals/fetchOverviewPreorder';
import {
  EveryCard,
  EveryCardBody,
  EveryCardHeadline,
  EveryCardPadding
} from 'blocks/EveryCard/EveryCard';
import HorizontalStackBlock from 'blocks/HorizontalStackBlock';
import ItemStackBlock from 'blocks/ItemStackBlock';
import Divider from 'components/Divider/Divider';
import Paragraph from 'components/Paragraph/Paragraph';
import TextElement from 'components/TextElement/TextElement';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const TextileOrderOverviewList = ({
  preordersAmount,
  order
}: {
  preordersAmount?: number;
  order?: CompleteOrder[];
}) => {
  return (
    <>
      {preordersAmount !== 0 && (
        <EveryCard disabled={true}>
          <EveryCardPadding>
            <EveryCardHeadline>
              <FormattedMessage id="Total amount" />
            </EveryCardHeadline>
            <EveryCardBody right={true}>
              <TextElement color="TEXT_DARK" size="L" weight="BOLD">
                {preordersAmount}
              </TextElement>
            </EveryCardBody>
          </EveryCardPadding>
        </EveryCard>
      )}

      <ItemStackBlock gap="S">
        <Paragraph color="TEXT_LIGHT" textAlign="right" size="XS">
          <FormattedMessage id="Pieces" />
        </Paragraph>
        {order &&
          order.map((itm) => {
            return (
              <ItemStackBlock gap="XXS" key={itm.size}>
                <HorizontalStackBlock justified={true}>
                  <HorizontalStackBlock gap="S">
                    <Paragraph color="TEXT_LIGHT">{itm.size}</Paragraph>
                  </HorizontalStackBlock>
                  <Paragraph color="TEXT_LIGHT">{itm.size_amount}</Paragraph>
                </HorizontalStackBlock>
                <Divider useStackBlockGap={true} />
              </ItemStackBlock>
            );
          })}
      </ItemStackBlock>
    </>
  );
};

export default TextileOrderOverviewList;
